import { render } from "./ComponentHero.vue?vue&type=template&id=436bc54f"
import script from "./ComponentHero.vue?vue&type=script&lang=js"
export * from "./ComponentHero.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__